import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartDetailsComponent } from './cart-details.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialMdcModule } from 'src/app/shared/material-mdc.module';



@NgModule({
  declarations: [CartDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    MaterialMdcModule
  ],
  exports: [CartDetailsComponent]
})
export class CartDetailsModule { }
